import UserContext from '@/context/UserContext';
import usePersistStore from '@/zustand-store/persist-config/usePersistStore';
import { useWallet } from '@solana/wallet-adapter-react';
import { useWalletModal } from '@solana/wallet-adapter-react-ui';
import { FC, useContext, useState } from 'react';
import { RiExchangeDollarLine } from 'react-icons/ri';
import { VscDebugDisconnect } from 'react-icons/vsc';
import { Link } from 'wouter';
import ConnectWalletModal from '../ConnectWalletModal';
import { MetamaskIconSmall, OwalletIcon } from '../icons/wallets';
import { useWalletManager } from '@/hooks/useWalletManager';

export type ConnectButtonProps = {
  setSettingModal?: (isOpen: boolean) => void;
  isHeader?: boolean;
};

export const ConnectButton: FC<ConnectButtonProps> = ({
  isHeader,
}: ConnectButtonProps) => {
  const { login } = useContext(UserContext);
  const { publicKey, wallet } = useWallet();
  const { setVisible } = useWalletModal();
  const [isVisibleEvm, setIsVisibleEvm] = useState(false);
  const { currentNetwork, evmTypeWallet } = usePersistStore();

  const { logOut } = useWalletManager();
  const { user } = usePersistStore();
  const { adapter: { icon = '' } = {} } = wallet || {};

  const WalletIcon =
    currentNetwork === 'evm' &&
    (evmTypeWallet === 'META_MASK' ? MetamaskIconSmall : OwalletIcon);

  const generateWalletAddress = () => {
    const isConnectedSol = currentNetwork === 'solana' && publicKey && login;
    const isConnectedEvm = currentNetwork === 'evm' && user.wallet;
    const addr = isConnectedSol
      ? publicKey.toBase58()
      : isConnectedEvm && user.wallet;
    return addr ? (
      <>
        <div className="flex mr-0 md:mr-3 items-center justify-center text-[16px] lg:text-md">
          {WalletIcon ? (
            <WalletIcon width={32} height={38} />
          ) : (
            icon && (
              <img
                src={icon}
                alt="Token IMG"
                className="rounded-full"
                width={24}
                height={24}
              />
            )
          )}
          <div className="ml-3">
            {addr.slice(0, 4)}....
            {addr.slice(-4)}
          </div>
        </div>
        <div className="hidden md:block w-[200px] absolute right-0 top-12 pt-2 invisible group-hover:visible">
          <ul className="border border-[rgba(88,90,107,0.24)] rounded bg-[#1A1C28] p-2 ">
            {addr && (
              <li>
                <Link
                  className="p-2 flex gap-2 items-center mb-1 text-primary-100 text-md tracking-[-0.32px] brightness-75 hover:brightness-125"
                  href={`/profile/${addr}`}
                >
                  <RiExchangeDollarLine />
                  View Profile
                </Link>
              </li>
            )}
            <li>
              <div
                className="p-2 flex gap-2 items-center text-primary-100 text-md tracking-[-0.32px] brightness-75 hover:brightness-125 text-[#E75787]"
                onClick={logOut}
              >
                <VscDebugDisconnect />
                Disconnect
              </div>
            </li>
          </ul>
        </div>
      </>
    ) : (
      <div
        className="flex text-nowrap whitespace-nowrap break-keep items-center justify-center gap-1 text-md uppercase cursor-pointer"
        onClick={() => {
          currentNetwork === 'solana'
            ? setVisible(true)
            : setIsVisibleEvm(true);
        }}
      >
        Connect
      </div>
    );
  };

  return (
    <div className="md:px-5 lg:px-0">
      <button className="w-full px-3 md:px-6  py-3 rounded bg-[#1A1C28] shadow-btn-inner text-[#E8E9EE] tracking-[0.32px] group relative cursor-pointer">
        {generateWalletAddress()}
      </button>
      <ConnectWalletModal
        isVisible={isVisibleEvm}
        setIsVisible={setIsVisibleEvm}
      />
      {login && user.wallet && !isHeader && (
        <div className="flex md:hidden justify-between items-center rounded bg-[#1A1C28] p-1">
          {user?.wallet && (
            <Link
              className="p-2  border-r border-[#4d4f58] text-[12px] flex-1 flex gap-2 items-center justify-center mb-1 text-primary-100 text-md tracking-[-0.32px] brightness-75 hover:brightness-125"
              href={`/profile/${user.wallet}`}
            >
              <RiExchangeDollarLine />
              View Profile
            </Link>
          )}
          <div
            className="p-2 text-[12px] flex flex-1 gap-2 items-center justify-center text-primary-100 text-md tracking-[-0.32px] brightness-75 hover:brightness-125 text-[#E75787]"
            onClick={logOut}
          >
            <VscDebugDisconnect />
            Disconnect
          </div>
        </div>
      )}
    </div>
  );
};
